"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Guard = _interopRequireDefault(require("./Guard"));

var _FirestoreConnection = _interopRequireDefault(require("./FirestoreConnection"));

var _Models = require("./Models");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars

/**
 * High-level api for vipro-online project
 */
class ViProOnlineApi {
  /**
   * Build an instance of the API by injecting the connection to firestore
   * @param {FirestoreConnection} firestore connection to firestore
   */
  constructor(firestore) {
    _Guard.default.requiresNotNull(firestore, 'firestore');

    this.firestore = firestore;
  }
  /**
   * Create the environment
   * @param {EnvironmentRequestModel} request the environment request to send
   * @param {String} appName the name of the calling application for the chronicle
   * @returns {Promise} the callback for this request
   */


  createNewRequest(request, appName) {
    _Guard.default.requiresNotNull(request, 'request');

    _Guard.default.requiresNotNull(request.requestId, 'request.requestId');

    request.services.addLog(new _Models.LogEntryModel((0, _Models.newId)(), appName, 'Environment request made'));
    return this.firestore.setObject(request.requestId, request);
  }
  /**
   * Append to the log
   * @param {LogEntryModel} logEntry the entry to append
   * @returns {Promise} the callback
   */


  addLogEntry(logEntry) {
    _Guard.default.requiresNotNull(logEntry, 'logEntry');

    _Guard.default.requiresNotNull(logEntry.requestId, 'logEntry.requestId');

    return this.firestore.mergeField(logEntry.requestId, {
      services: {
        log: {
          [(0, _Models.newId)()]: logEntry
        }
      }
    });
  }
  /**
   * Register details for a service endpoint
   * @param {String} name the name of this service endpoint to add
   * @param {*} endpoint the service endpoint to add
   * @returns {Promise} the callback
   */


  addServiceEndpoint(requestId, name, endpoint) {
    _Guard.default.requiresNotNull(requestId, 'requestId');

    _Guard.default.requiresNotNull(name, 'logEntry');

    _Guard.default.requiresNotNull(endpoint, 'endpoint');

    return this.firestore.mergeField(requestId, {
      services: {
        endpoints: {
          [name]: endpoint
        }
      }
    });
  }

}

exports.default = ViProOnlineApi;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vigilantapps/vipro-online-request-manager/dist/ViProOnlineApi.js
// module id = Je8X
// module chunks = 0